import React, { useState } from "react";
import styles from "./Services.module.css";
import { BookOpen, GraduationCap, Truck, Check, ArrowLeft } from "lucide-react";

const SERVICES = [
  {
    id: "01",
    icon: <BookOpen size={20} />,
    color: "#1b3d6c",
    colorLight: "rgba(27, 61, 108, 0.06)",
    title: "مراجع علمية متخصصة",
    subtitle: "مراجع علمية متخصصة للمعلمين والطلاب",
    description:
      "نوفر أشمل تشكيلة من المراجع العلمية المتخصصة المصممة خصيصاً لاحتياجات المعلمين والطلاب في جميع المراحل الدراسية. كل مرجع مختار بعناية ليكون رفيقك الأمثل في رحلة التعلم.",
    features: [
      "مراجع متخصصة لجميع المواد الدراسية",
      "مخصصة لكل من المعلم والطالب على حدة",
      "محتوى علمي موثوق ومعتمد أكاديمياً",
    ],
    image:
      "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=700&q=80",
  },
  {
    id: "02",
    icon: <GraduationCap size={20} />,
    color: "#ff791a",
    colorLight: "rgba(255, 121, 26, 0.06)",
    title: "كتب لجميع المراحل التعليمية",
    subtitle: "كتب دراسية شاملة لجميع المراحل التعليمية",
    description:
      "من رياض الأطفال حتى الثالث الثانوي — عندنا كل الكتب الدراسية التي يحتاجها ابنك أو طالبك بأعلى جودة طباعة وأوضح محتوى، وكلها في مكان واحد بدون عناء البحث.",
    features: [
      "كتب لجميع المراحل من الابتدائي للثانوي",
      "مناهج رسمية معتمدة ومحدّثة",
      "تغطية شاملة لجميع المواد والتخصصات",
    ],
    image:
      "https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=700&q=80",
  },
  {
    id: "03",
    icon: <Truck size={20} />,
    color: "#0ca678",
    colorLight: "rgba(12, 166, 120, 0.06)",
    title: "توصيل سريع ومضمون",
    subtitle: "توصيل سريع ومضمون لجميع أنحاء الجمهورية",
    description:
      "طلبك يوصلك أينما كنت في مصر — شبكة توصيل سريعة وموثوقة تضمن وصول كتبك مغلفةً بأمان وفي أسرع وقت ممكن. لأن وقتك ثمين والمذاكرة لا تنتظر.",
    features: [
      "توصيل لجميع محافظات الجمهورية",
      "تغليف محكم يحمي كتبك أثناء الشحن",
      "تتبع الطلب لحظة بلحظة",
    ],
    image:
      "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=700&q=80",
  },
];

const Services = () => {
  const [active, setActive] = useState(0);
  const current = SERVICES[active];

  return (
    <section className={styles.section} id="services">
      <div className={styles.inner}>
        <div className={styles.intro}>
          <span className={styles.tag}>خدمات MyStore</span>
          <h2 className={styles.mainTitle}>
            كل اللي تحتاجه للمذاكرة <em className={styles.em}>في مكان واحد</em>
          </h2>
          <p className={styles.subPara}>
            في MyStore بنوفرلك كل الكتب الدراسية والمراجع العلمية المتخصصة لجميع
            المراحل التعليمية — بجودة عالية وأسعار منافسة وتوصيل سريع لأي مكان
            في مصر.
          </p>
        </div>

        <div className={styles.tabs}>
          {SERVICES.map((s, i) => (
            <button
              key={i}
              className={`${styles.tab} ${i === active ? styles.tabActive : ""}`}
              style={
                i === active
                  ? {
                      color: s.color,
                      borderColor: s.color,
                      background: s.colorLight,
                    }
                  : {}
              }
              onClick={() => setActive(i)}
            >
              <span className={styles.tabIcon}>{s.icon}</span>{" "}
              <span className={styles.tabLabel}>{s.title}</span>
            </button>
          ))}
        </div>

        <div className={styles.content} key={active}>
          <div
            className={styles.imgWrap}
            style={{ background: current.colorLight }}
          >
            <img
              src={current.image}
              alt={current.title}
              className={styles.img}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
            <span className={styles.giantNum} style={{ color: current.color }}>
              {current.id}
            </span>
          </div>

          <div className={styles.textBlock}>
            <h3
              className={styles.serviceTitle}
              style={{ color: current.color }}
            >
              {current.title}
            </h3>
            <h4 className={styles.serviceSubtitle}>{current.subtitle}</h4>
            <p className={styles.serviceDesc}>{current.description}</p>

            <ul className={styles.checklist}>
              {current.features.map((f, i) => (
                <li key={i} className={styles.checkItem}>
                  <span
                    className={styles.checkIcon}
                    style={{
                      background: current.colorLight,
                      color: current.color,
                    }}
                  >
                    <Check size={14} strokeWidth={3} />{" "}
                  </span>
                  {f}
                </li>
              ))}
            </ul>

            <button
              className={styles.exploreBtn}
              style={{ background: current.color }}
            >
              اكتشف المزيد ←
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
